import { render, staticRenderFns } from "./StripeLogo.vue?vue&type=template&id=98389bf8&functional=true&"
var script = {}
import style0 from "./StripeLogo.vue?vue&type=style&index=0&id=98389bf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.10_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports